<template>
    <BreadCrumb PageTitle="Detail de contrat" />
    <ViewContrat />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
      import ViewContrat from "@/components/Contrat/ViewContrat.vue";
  
    export default defineComponent({
      name: "ViewContratPage",
      components: {
        BreadCrumb,
        ViewContrat,
      },
    });
  </script>